import React, { useState, useEffect } from "react";
import { text_truncate } from "../../../helpers/helpers";
import { SortableElement, SortableHandle } from "react-sortable-hoc";
import { PeriodTypeInlineMultiSelector } from "../Filters/PeriodTypeInlineMultiSelector";
import { PracticePeriodProps } from "./types";

const DragHandle = SortableHandle(() => (
  <div className="profile-g">
    <button>
      <img src="/assets/dots.svg" alt="" height="20px" />
    </button>
  </div>
));

const PracticePeriod = SortableElement(
  ({
    league,
    name,
    types,
    removePeriod,
    id,
    editPeriod,
    style,
    teamId,
  }: PracticePeriodProps) => {
    const [edit, setEdit] = useState(false);
    const [periodName, setPeriodName] = useState(name);
    const [periodTypes, setPeriodTypes] = useState(types);
    useEffect(() => {
      setPeriodName(name);
      setPeriodTypes(types);
    }, [name, types]);
    return (
      <li className="profile-dot" key={id} style={style}>
        <DragHandle />
        <div className="profile-q">
          {!edit ? (
            text_truncate(periodName, 25)
          ) : (
            <input
              type="text"
              value={periodName}
              onChange={(e) => setPeriodName(e.target.value)}
            />
          )}
        </div>
        <div className="profile-period-type">
          <PeriodTypeInlineMultiSelector
            changeItemsSelected={(values) =>
              setPeriodTypes(values.map((value) => value.value).join(","))
            }
            selectedItems={!periodTypes ? [] : periodTypes.split(",")}
            editable={edit}
            league={league}
            id={id}
            teamId={teamId}
          />
        </div>
        <div className="profile-x">
          {edit ? (
            <>
              <button
                onClick={() => {
                  editPeriod(id, periodName, periodTypes);
                  setEdit(false);
                }}
              >
                <i className="mdi mdi-check"></i>
              </button>
              <button
                onClick={() => {
                  setPeriodName(name);
                  setEdit(false);
                }}
              >
                <i className="mdi mdi-close"></i>
              </button>
            </>
          ) : (
            <>
              <button onClick={() => setEdit(true)}>
                <img src="/assets/edit.svg" alt="" height="25px" />
              </button>

              <button onClick={() => removePeriod(id)}>
                <i className="mdi mdi-delete" />
              </button>
            </>
          )}
        </div>
      </li>
    );
  }
);

export default PracticePeriod;
